export const BADGES = {
    PRO: 'pro',
    CHOICE: 'choice',
    BUSINESS: 'business',
};
